import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "antd/dist/antd.css";
import Dashboard from "./components/Dashboard/Main";
import Register from "./components/Auth/Register";
import Login from "./components/Auth/Login";
import Products from "./components/Product/Products";
import Product from "./components/Product/Product";
import Categories from "./components/Category/Categories";
import Category from "./components/Category/Category";
import Orders from "./components/Order/Orders";
import Order from "./components/Order/Order";
import Error from "./components/Layout/Error";
import Customers from "./components/Customer/Customers";
import Customer from "./components/Customer/Customer";
import StoreSettings from "./components/Store/StoreSettings";
import EditStoreInfo from "./components/Store/EditStoreInfo";
import Shipping from "./components/Store/Shipping/Shipping";
import { getStore } from "./actions/store";
import { useDispatch, useSelector } from "react-redux";
import CreateStore from "./components/Store/CreateStore";
import Stores from "./components/SuperAdmin/Stores/Stores";
import ViewStore from "./components/SuperAdmin/Stores/ViewStore";
import StaticInfo from "./components/Website/StaticInfo";
import Contact from "./components/Contact/Contact";

const App = () => {
  const currentUser = JSON.parse(localStorage.getItem("profile"));
  const cc = useSelector((state) => state.store)?.store?.storeInfo?.currency;
  const storeCurrency = cc ? cc.substring(0, 1) : cc;
  const [superAdmin, setSuperAdmin] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      if (currentUser?.store) {
        dispatch(getStore(currentUser?.store));
      }
    }, 1000);

    if (currentUser?.role === "SUPER_ADMIN") {
      setSuperAdmin(true);
    } else {
      setSuperAdmin(false);
    }
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="*" element={<Error />} />
        <Route path="/" exact element={<Login />} />
        <Route path="/register" exact element={<Register />} />

        <Route
          path="/dashboard"
          exact
          element={
            <Dashboard
              storeCurrency={storeCurrency}
              currentUser={currentUser}
              superAdmin={superAdmin}
            />
          }
        />

        {!superAdmin ? (
          <>
            <Route
              path="/products"
              exact
              element={
                <Products
                  storeCurrency={storeCurrency}
                  currentUser={currentUser}
                />
              }
            />
            <Route
              path="/product/new"
              exact
              element={
                <Product
                  storeCurrency={storeCurrency}
                  currentUser={currentUser}
                />
              }
            />
            <Route
              path="/product/:id"
              exact
              element={
                <Product
                  storeCurrency={storeCurrency}
                  currentUser={currentUser}
                />
              }
            />

            <Route
              path="/categories"
              exact
              element={<Categories currentUser={currentUser} />}
            />
            <Route
              path="/category/new"
              exact
              element={<Category currentUser={currentUser} />}
            />
            <Route
              path="/category/:id"
              exact
              element={<Category currentUser={currentUser} />}
            />

            <Route
              path="/orders"
              exact
              element={
                <Orders
                  currentUser={currentUser}
                  storeCurrency={storeCurrency}
                />
              }
            />
            <Route
              path="/order/new"
              exact
              element={
                <Order
                  currentUser={currentUser}
                  storeCurrency={storeCurrency}
                />
              }
            />
            <Route
              path="/order/:id"
              exact
              element={
                <Order
                  currentUser={currentUser}
                  storeCurrency={storeCurrency}
                />
              }
            />

            <Route
              path="/customers"
              exact
              element={<Customers currentUser={currentUser} />}
            />
            <Route
              path="/customer/new"
              exact
              element={<Customer currentUser={currentUser} />}
            />
            <Route
              path="/customer/:id"
              exact
              element={<Customer currentUser={currentUser} />}
            />

            <Route path="/store" exact element={<StoreSettings />} />
            <Route
              path="/createStore"
              exact
              element={
                <CreateStore
                  currentUser={currentUser}
                  storeCurrency={storeCurrency}
                />
              }
            />
            <Route
              path="/storeinfo"
              exact
              element={
                <EditStoreInfo
                  currentUser={currentUser}
                  storeCurrency={storeCurrency}
                />
              }
            />

            <Route
              path="/website"
              exact
              element={<StaticInfo currentUser={currentUser} />}
            />

            <Route
              path="/shipping"
              exact
              element={
                <Shipping
                  currentUser={currentUser}
                  storeCurrency={storeCurrency}
                />
              }
            />
            <Route
              path="/shipping/:id"
              exact
              element={
                <Shipping
                  currentUser={currentUser}
                  storeCurrency={storeCurrency}
                />
              }
            />

            <Route
              path="/contact"
              exact
              element={<Contact currentUser={currentUser} />}
            />
          </>
        ) : (
          <>
            <Route
              path="/stores"
              exact
              element={<Stores currentUser={currentUser} />}
            />
            <Route path="/store/:id" exact element={<ViewStore />} />
          </>
        )}
      </Routes>
    </Router>
  );
};

export default App;
